import React from 'react';
import PropTypes from 'prop-types';
import { Modal, notification } from 'antd';
import { UserContext } from '../../../hoc/User';
import api from '../../../utils/api';
import styles from './styles.less';
import Picture from '../../Picture';
import Button from '../../Button';
import TextArea from '../../Input/TextArea';
import { LocalizationContext } from '../../../hoc/Localization';
import { RouteContext } from '../../../hoc/Route';
import { SettingsContext } from '../../../hoc/Settings';
import { SecurityContext } from '../../../hoc/Security';

const ClaimOwnership = ({ school = {} }) => {
  const { user } = React.useContext(UserContext);
  const [loading, setLoading] = React.useState(false);
  const [note, setNote] = React.useState(null);

  const { locale, t } = React.useContext(LocalizationContext);
  const {
    domainSettings: { domain, schoolId, onboardingCourseId },
  } = React.useContext(SettingsContext);
  const { params } = React.useContext(RouteContext);
  const { visible, setVisible } = React.useContext(SecurityContext);

  React.useEffect(() => {
    if (params.claim === 'claim') {
      setVisible(true);
    }
  }, []);

  const isOwner =
    !!user &&
    (user.isAdmin ||
      (!!school.schoolOwners &&
        !!school.schoolOwners.find(o => o.external_id === user.external_id)));

  const submitClaim = async () => {
    setLoading(true);

    try {
      const { status, message } = await api.post(`schools/${school.id}/add-owner`, {
        school: {
          id: school.id,
          name: school.title,
        },
        note,
        locale,
        domain,
        schoolId,
        onboardingCourseId,
      });

      notification[status]({ message });

      setVisible(false);
    } catch (e) {
      notification.error({ message: e.message });
    } finally {
      setLoading(false);
    }
  };
  const link = (
    <a data_gh="claim_ownership_link" onClick={() => setVisible(true)}>
      Claim ownership
    </a>
  );

  return isOwner ? null : (
    <>
      <Modal
        visible={visible && user}
        footer={null}
        onCancel={() => setVisible(false)}
        className={styles.claim}
      >
        <h1 className={styles.title}>{t('details.report.claim')}</h1>
        <div className={styles.school}>
          <Picture src={school.logo} alt={school.title} />
          <p>{school.title}</p>
        </div>

        <div className={styles.note}>
          {/* eslint-disable-next-line */}
          <label>{t('claim.ownership.additional.note')}</label>
          <TextArea
            placeholder={t('claim.ownership.additional.note.text')}
            onInput={e => setNote(e.target.value)}
            disabled={loading}
            data_gh="claim_ownership_textarea"
          />
        </div>
        <div className={styles.claimOwnershipButton}>
          <Button
            type="primary"
            data_gh="claim_ownership_button"
            loading={loading}
            onClick={submitClaim}
          >
            {t('claim.ownership.button')}
          </Button>
        </div>
      </Modal>

      {link}
    </>
  );
};

ClaimOwnership.propTypes = {
  school: PropTypes.object.isRequired,
};

export default ClaimOwnership;
